module.exports = __webpack_public_path__ + "e885709e5dbe52a30dc4ad52d1b8d180.svg";